import CreateAccountPage from './CreateAccountPage';
export default CreateAccountPage;
